import { endpoints, request } from '!core/api';

export const changePasswordServices = {
  getPasswordPolicies: () =>
    request.get(endpoints.framework(`PasswordPolicies`)),
  changePassword: ({
    username,
    oldHashPassword,
    newHashPassword,
    newSalt,
    otp,
  }) =>
    request.postWebService(endpoints.webservices('changepassword'), {
      username,
      oldKey: oldHashPassword,
      newKey: newHashPassword,
      newSalt,
      otp,
    }),
  salt: async (user) =>
    request.getWebService(endpoints.webservices(`userInfo?username=${user}`)),
};
